export default {
  productService: {
    'aiInternet': {
      title: 'AI + 互联网系列',
      icon: require('../imgs/product-service/icon_cm.png'),
      items: [{
        title: '内容安全',
        info: '识别图像中可能令人反感、不安全或不适宜内容，一体化接入，节约人力成本',
        url: 'OPEN_SOLUTION_AUDITING'
      }, {
        title: 'FaceIn人脸核身',
        info: '高准确率、高安全性的人脸核身解决方案，国内第一家在金融行业全量上线',
        url: 'OPEN_SOLUTION_FACEIN'
      }, {
        title: 'FaceIn人脸防伪',
        info: '精准识别虚假人脸，提高影像鉴别能力',
        url: 'OPEN_SOLUTION_FACEIN_FW'
      }, {
        title: '未成年人内容安全审核',
        info: '用AI的力量净化网络环境，守护青少年健康成长',
        url: 'OPEN_SOLUTION_ADULT'
      }, {
        title: '腾讯云智媒体AI中台',
        info: '为传媒行业量身打造，集合顶尖AI能力的全栈式AI服务管理平台',
        url: 'OPEN_SOLUTION_TIM'
      }]
    },
    'financial': {
      title: '金融系列',
      icon: require('../imgs/product-service/icon_jr.png'),
      items: [{
        title: '财务票据',
        info: '财务票据数字化解决方案',
        url: 'OPEN_SOLUTION_INVOICE'
      }, {
        title: '智能保险',
        info: '基于优图OCR服务，提供保险行业中核保、理赔等场景的智能识别解决方案',
        url: 'OPEN_SOLUTION_INSURANCE'
      }]
    },
    'aiEducation': {
      title: 'AI + 教育系列',
      icon: require('../imgs/product-service/icon_zw.png'),
      items: [{
        title: '优图教育',
        info: '优图教育OCR解决方案',
        url: 'OPEN_SOLUTION_EDUCATION'
      }]
    },
    'sdkProduct': {
      title: 'SDK产品系列',
      icon: require('../imgs/product-service/icon_sdk.png'),
      items: [{
        title: '泛娱乐sdk产品系列',
        info: '帮助您轻松接入娱乐类SDK产品，丰富您的移动端社交娱乐产品',
        url: 'OPEN_SOLUTION_SDKPRODUCTION'
      }]
    }
  },
  newsCenter: [
    {
      title: '​腾讯云xDeepSeek：率先上线最新版V3模型API接口、大模型知识引擎内置新模型服务',
      date: '2025年3月26日',
      url: 'OPEN_NEWS_72'
    },
    {
      title: '腾讯2024年财报：To B营收2120亿元创新高，元宝日活增长超20倍',
      date: '2025年3月20日',
      url: 'OPEN_NEWS_71'
    },
    {
      title: 'CVPR 2025｜腾讯优图实验室22篇论文入选，含深度伪造检测、自回归视觉生成、多模态大语言模型等研究方向',
      date: '2025年3月19日',
      url: 'OPEN_NEWS_82'
    },
    {
      title: 'ICLR 2025｜腾讯优图实验室6篇论文入选，含多模态大语言模型、人脸识别等研究方向',
      date: '2025年3月12日',
      url: 'OPEN_NEWS_81'
    },
    {
      title: '火热报名中| 第五届Light创造营邀你一起破茧成光！',
      date: '2025年3月6日',
      url: 'OPEN_NEWS_77'
    },
    {
      title: '第五届Light创造营启动！提供全方位技术支持，助力公益可持续创新',
      date: '2025年3月3日',
      url: 'OPEN_NEWS_76'
    }
  ]
};

/*
const cloudFaceIdentify = 'https://cloud.tencent.com/product/facerecognition';
const cloudbodyIdentify = 'https://cloud.tencent.com/product/bda';
const cloudOcrIdentify = 'https://cloud.tencent.com/product/ocr-catalog';
const cloudImageIdentify = 'https://cloud.tencent.com/product/tiia';
const commonCloud = {
  'faceIdentify': {
    title: '人脸识别',
    info: '可精准实现人脸检测、人脸关键点定位、人脸属性分析等相关能力，满足多种业务需求。',
    items: [{
      title: '人脸检测与分析',
      info: '对于任意一幅给定的图像，智能返回是否有人脸以及相应的属性分析。',
      url: cloudFaceIdentify
    }, {
      title: '人脸验证',
      info: '提取人脸特征，计算两张人脸的相似度，从而判断是否为同一人，即1：1。',
      url: cloudFaceIdentify
    }, {
      title: '人脸关键点定位与追踪',
      info: '精确定位并追踪面部的关键区域位置，包括眉毛、眼睛、鼻子、嘴巴和脸部轮廓等。',
      url: cloudFaceIdentify
    }]
  },
  'bodyIdentify': {
    title: '人体识别',
    info: '可实现人像分割、手势识别、人体关键点检测等多种人体能力，解锁人机交互新方式。',
    items: [{
      title: '人像分割',
      info: '指对图片或视频中的半身人体轮廓范围进行识别，将其与背景进行分离。',
      url: cloudbodyIdentify
    }, {
      title: '人体关键点检测',
      info: '可检测图像中的人体并返回人体矩形框位置，精准定位14个核心关键点。',
      url: cloudbodyIdentify
    }, {
      title: '手势识别',
      info: '可精准识别多达11种手势，并可在移动端实现实时的手势跟踪。',
      url: cloudbodyIdentify
    }]
  },
  'faceSpecialEffects': {
    title: '人像特效',
    info: 'AI人像特效玩法，带来不一样的娱乐体验，可实现人脸融合、人像美颜等多种功能。',
    items: [{
      title: '人脸融合',
      info: '对于用户上传的人脸照与特定的照片进行融合处理，生成的人脸同时具备两张人脸的外貌特征。',
      url: 'https://cloud.tencent.com/product/facefusion'
    }, {
      title: '人脸试妆',
      info: '为您提供精准、自然、高效的虚拟妆容，包含AI试唇色、AI试眼妆、AI试底妆、AI试腮红、人像美颜等多种能力。',
      url: 'https://cloud.tencent.com/product/fmu'
    }, {
      title: '人脸性别变换',
      info: '输出一张人脸性别转换的结果。其中，男变女可具备美颜、淡妆、加刘海和长发效果；男变女可具备加胡须，变短发效果。',
      url: 'https://cloud.tencent.com/product/ft'
    }]
  },
  'ocrIdentify': {
    title: 'OCR识别',
    info: '提供多种的高精度、高准确率的文字检测和识别服务，应用于各行各业。',
    items: [{
      title: '通用文字识别',
      info: '提供图片内多种语言文字自动检测和识别服务，返回语种类型、文字框位置与文字内容。',
      url: cloudOcrIdentify
    }, {
      title: '个人证照识别',
      info: '提供身份证、多个国家和地区护照、名片、银行卡、机动车驾驶证等多种证照识别能力。',
      url: cloudOcrIdentify
    }, {
      title: '财务报销凭证识别',
      info: '支持增值税发票、购车发票、火车票、出租车发票、定额发票等多种报销凭证的结构化识别。',
      url: cloudOcrIdentify
    }]
  },
  'imageIdentify': {
    title: '图像识别',
    info: '提供不宜内容识别，车辆属性、图片标签识别等图像识别能力，用AI捍卫互联网安全。',
    items: [{
      title: '不宜内容识别',
      info: '目标图片经过系统识别之后，会给出其不宜内容图片的概率，对高置信度有效打击，可帮助用户鉴别不宜内容图片。',
      url: cloudImageIdentify
    }, {
      title: '图片标签识别',
      info: ' 准确快速地检测图像中的内容信息，返回检测出的内容名称以及相应置信度。',
      url: cloudImageIdentify
    }, {
      title: '车辆属性识别',
      info: '对用户上传的汽车图片自动地检测车身以及识别车辆属性。',
      url: cloudImageIdentify
    }]
  }
};
*/



// WEBPACK FOOTER //
// ./src/components/open/panels/home/data/ModuleData.js